import React from "react";
import "./shell.css";

export const Shell: React.FC = ({ children }) => {
  return <>{children}</>;
};
